import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createValueCatalogCard } from "src/business/valueCatalog/apiValueCatalog";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { PageLayout } from "src/components/PageLayout";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { ValueCatalogRecForm } from "../ValueCatalogRecForm";
import {
  ValueCatalogRecNewData,
  valueCatalogRecNewStore as pageStore,
} from "./ValueCatalogRecNewStore";

export const ValueCatalogRecNew: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.crumbs}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: ValueCatalogRecNewData }> = observer(
  ({ data }) => {
    const navigate = useNavigate();
    return (
      <ValueCatalogRecForm
        title={pageStore.title}
        okText="Создать"
        form={pageStore.form}
        submit={(dataMap) => createValueCatalogCard(data.catalog.id, dataMap)}
        onSuccess={({ id }) => {
          msgQueueStore.add({
            type: "success",
            message: "Создана запись каталога значений",
          });
          // редирект на карточку редактирования
          navigate(makeUrl(PageUrl.valueCatalogEdit, { id }), {
            replace: true,
          });
        }}
      />
    );
  },
);
